import { FC } from "react"
import classNames from "classnames"

type Props = {
  size: "small" | "medium"
}

export const Loader: FC<Props> = ({ size }) => {
  const styles = classNames({
    "animate-spin": true,
    "border border-2": true,
    "border-gray-600": true,
    "border-l-slate-200": true,
    "rounded-full": true,
    "h-4": size === "small",
    "w-4": size === "small",
    "h-6": size === "medium",
    "w-6": size === "medium",
  })

  return (
    <div className="flex items-center">
      <div className={styles}></div>
    </div>
  )
}
